import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useCreateApplication } from "../../api/applications";
import { useToast } from "../../components/ToastProvider";

const DIACRITICS_RE = new RegExp("[\\u0300-\\u036f]", "g");

function slugify(name: string): string {
  return name
    .toLowerCase()
    .normalize("NFD")
    .replace(DIACRITICS_RE, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

export function NewApplicationModal({ show, onClose }: { show: boolean; onClose: () => void }) {
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [version, setVersion] = useState("");
  const [error, setError] = useState<string | null>(null);
  const create = useCreateApplication();
  const toast = useToast();

  function reset() {
    setName("");
    setCategory("");
    setDescription("");
    setVersion("");
    setError(null);
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim()) {
      setError("Informe o nome da aplicação.");
      return;
    }
    try {
      await create.mutateAsync({ name, slug: slugify(name), category, description, version });
      toast("Aplicação cadastrada.");
      reset();
      onClose();
    } catch {
      setError("Não foi possível cadastrar a aplicação.");
    }
  }

  return (
    <Modal backdrop="static" keyboard={false} show={show} onHide={onClose} centered className="nt-dialog" contentClassName="p-1">
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title style={{ fontSize: 20, fontFamily: "var(--font-heading)" }}>Nova aplicação</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column gap-3">
          <div className="field">
            <label className="form-label" style={{ fontSize: 12 }}>
              Nome
            </label>
            <input className="form-control" value={name} onChange={(e) => setName(e.target.value)} placeholder="Ex.: Gestor de Pedidos" />
          </div>
          <div className="field">
            <label className="form-label" style={{ fontSize: 12 }}>
              Categoria
            </label>
            <input className="form-control" value={category} onChange={(e) => setCategory(e.target.value)} placeholder="Ex.: SaaS · food service" />
          </div>
          <div className="field">
            <label className="form-label" style={{ fontSize: 12 }}>
              Descrição
            </label>
            <textarea className="form-control" value={description} onChange={(e) => setDescription(e.target.value)} rows={2} />
          </div>
          <div className="field">
            <label className="form-label" style={{ fontSize: 12 }}>
              Versão
            </label>
            <input className="form-control" value={version} onChange={(e) => setVersion(e.target.value)} placeholder="Ex.: 1.0.0" />
          </div>
          {error && (
            <div className="text-danger" style={{ fontSize: 12.5 }}>
              {error}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-danger" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="btn btn-success" disabled={create.isPending}>
            Cadastrar aplicação
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
